import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20light%20radiating%20through%20soft%20mist%20in%20a%20minimalist%20temple%20interior%2C%20ancient%20wooden%20pillars%2C%20incense%20smoke%20drifting%20upward%2C%20serene%20spiritual%20atmosphere%2C%20soft%20ethereal%20glow%2C%20warm%20amber%20and%20cream%20tones%2C%20peaceful%20meditative%20mood%2C%20fine%20art%20spiritual%20photography&width=1600&height=900&seq=hero-prajna-main&orientation=landscape"
          alt="般若智慧修行"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <p className="text-sm md:text-base text-background-50/80 font-medium tracking-widest mb-4 font-heading">
            {t('hero_subtitle')}
          </p>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-background-50 mb-6 tracking-wide">
            {t('hero_title')}
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            {t('hero_description')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/xin-jing-jie-du"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('hero_cta_articles')}
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/15 text-background-50 font-medium text-sm hover:bg-background-50/25 transition-colors border border-background-50/30 cursor-pointer whitespace-nowrap"
            >
              {t('hero_cta_about')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}